interface SectionTitleProps {
  title?: React.ReactNode;
  description?: React.ReactNode;
  size?: 'sm' | 'md' | 'lg';
}

export default function SectionTitle({
  title,
  description,
  size = 'lg',
}: SectionTitleProps) {
  const sizeClasses = {
    sm: {
      title: 'text-[16px] 3xl:text-[18px]',
      description: 'text-[12px] 3xl:text-sm',
    },
    md: {
      title: 'text-[18px] 3xl:text-[20px]',
      description: 'text-[14px] 3xl:text-[15px]',
    },
    lg: {
      title: 'text-[20px] 3xl:text-[22px]',
      description: 'text-[14px] 3xl:text-base',
    },
  };

  return (
    <div className="flex flex-col items-start justify-between">
      <div
        className={`font-bold text-text-primary-heading whitespace-nowrap ${sizeClasses[size].title}`}
      >
        {title}
      </div>
      {description && (
        <p
          className={`text-text-primary-body mt-1.5 ${sizeClasses[size].description}`}
        >
          {description}
        </p>
      )}
    </div>
  );
}
